import { AccessLevel } from "@/graphql/generated/operations";

// Wer darf was am Projekt. Drei Achsen in genesis (Plan, Kandidaten, Ablauf),
// aber nur ZWEI Rollen an der Oberfläche: verwalten oder sehen.
//
// Die Achsen einzeln zu zeigen wäre ehrlicher zum Datenmodell und falsch für den
// Menschen - er denkt nicht in "darf die Kandidatenliste schreiben, aber den
// Ablauf nur lesen", sondern in "der macht mit" und "der schaut zu". Match führt
// dieselbe Übersetzung (match-access.ts), nur mit vier Achsen und drei Rollen,
// weil dort eine Zwischenstufe wirklich gebraucht wird.
//
// Der ERSTELLER steht nie in dieser Liste: er sieht das Projekt, weil er es
// angelegt hat (ProjectVisibilityScope). Nähme man ihn auf, könnte man ihn
// versehentlich entfernen und sein eigenes Projekt verlieren.

export type ProjectRole = "admin" | "reader";

export interface ProjectAccessAxes {
  plan: AccessLevel;
  candidates: AccessLevel;
  timeline: AccessLevel;
}

export function roleToAxes(role: ProjectRole): ProjectAccessAxes {
  return role === "admin"
    ? { plan: AccessLevel.Write, candidates: AccessLevel.Write, timeline: AccessLevel.Write }
    : { plan: AccessLevel.Read, candidates: AccessLevel.Read, timeline: AccessLevel.Read };
}

/**
 * Zurück auf die Rolle. Alles, was irgendwo schreiben darf, gilt als verwaltend:
 * eine Mischung aus Schreib- und Leserechten kann über die API entstehen, und
 * sie als "sehen" anzuzeigen würde ein Recht verschweigen, das die Person hat.
 */
export function axesToRole(axes: ProjectAccessAxes): ProjectRole {
  return axes.plan === AccessLevel.Write ||
    axes.candidates === AccessLevel.Write ||
    axes.timeline === AccessLevel.Write
    ? "admin"
    : "reader";
}

export const PROJECT_ROLE_LABELS: Record<ProjectRole, { id: string; defaultMessage: string }> = {
  admin: { id: "project.access.roleAdmin", defaultMessage: "Verwalten" },
  reader: { id: "project.access.roleReader", defaultMessage: "Sehen" },
};
